<template>
  <div class="login-wrapper login-container login-height">
    <b-container fluid>
      <b-row align-v="center" align-h="end" class="login-height">
        <b-col md="5" class="inner-content">
          <b-card class="m-4 p-4 bg-t-dark">
            <b-row>
              <b-col>
                <LoginForm v-if="!forgot_password && !set_password" />
                <ForgotPassword v-else-if="!set_password" />
                <ResetPassword v-else />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import LoginForm from '@/views/login/components/LoginForm.vue'
import ForgotPassword from '@/views/login/components/ForgotPassword.vue'
import ResetPassword from '@/views/login/components/ResetPassword.vue'
export default {
  components: {
    ResetPassword,
    ForgotPassword,
    LoginForm
  },
  mounted() {
    this.$store.state.logged = false
    this.set_password = this.$route.query.token ? true : false
  },
  data() {
    return {
      forgot_password: false,
      set_password: false,
    }
  }
}
</script>

<style lang="scss">
.login-wrapper {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("@/assets/img/banner.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  ::placeholder {
    color: #afafaf !important;
  }
}

.login-height {
  height: 100vh;
}

.inner-content {
  margin-right: 3rem;
}

.login-wrapper .card.bg-t-dark {
  background-color: rgba(35, 48, 68, 0.6) !important;

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  border-radius: 15px !important;

  border: 2px solid rgba(70, 70, 70, 0.3);
}

.login-wrapper .card .form-control {
  height: 60px !important;
}
</style>